export const getWishlistsPath = (regionCode: string) =>
  `/${regionCode.toLowerCase()}/wishlists`

export const getWishlistPath = (regionCode: string, wishlistId: string) =>
  `${getWishlistsPath(regionCode)}/${wishlistId}`

export const getBrowseOffersPath = (regionCode: string) =>
  `/${regionCode.toLowerCase()}`
